import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';

let id = 1;

@Component({
  selector: 'app-send-invitation-event-popover',
  templateUrl: './send-invitation-event-popover.component.html',
  styleUrls: ['./send-invitation-event-popover.component.scss']
})
export class SendInvitationEventPopoverComponent {

  @ViewChild('popover') popover: MdbPopoverDirective = null;
  
  @Input() event:any = null

  private _id = id++;
  get id() {
    return `SendInvitationEventPopover_${this._id}`;
  }

  constructor(
    private router: Router,
    private popoverService: PopoverService,
  ) { }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onClickSendInvitation(event, eventType = null, inviteType = null) {
    window['eventReportInvitationsModal'].reset();
    switch(event.type) {
      case 0:
        window['eventReportInvitationsModal'].event = event.inPersonEventInfo;
        window['orgMain'].showEventInvitationModal(event.inPersonEventInfo.id, eventType, inviteType).then(() => {
            window['toastr'].success("Invitations Sent!");
            this.onClickReport(event, eventType);
            window['$']('#panelInPersonEventPageInviteTab').click();
            window['$']('#inviteVirtualGuestsModal').modal('hide');
        }, () => {});
        break;
      case 1:
        window['eventReportInvitationsModal'].vEvent = event.virtualEventInfo;
        window['orgMain'].showEventInvitationModal(event.virtualEventInfo.id, eventType, inviteType).then(() => {
            window['toastr'].success("Invitations Sent!");
            this.onClickReport(event, eventType);
            switch(inviteType) {
              case 0:
                window['$']('#panelInvitationsTab').click();
                break;
              case 1:
                window['$']('#panelEventPageInvitationsTab').click();
                break;
            }
            window['$']('#inviteVirtualGuestsModal').modal('hide');
        }, () => {});
        break;
      case 2:
        let eventInfo = null;
        if(eventType === 0) {
          eventInfo = event.hybridEventInfo.inPersonEvent;
          window['eventReportInvitationsModal'].event = eventInfo;
        } else {
          eventInfo = event.hybridEventInfo.virtualEvent;
          window['eventReportInvitationsModal'].vEvent = eventInfo;
        }
        window['orgMain'].showEventInvitationModal(eventInfo.id, eventType, inviteType).then(() => {
            window['toastr'].success("Invitations Sent!");
            this.onClickReport(event, eventType);
            switch(eventType) {
              case 0:
                window['$']('#panelInPersonEventPageInviteTab').click();
                break;
              case 1:
                switch(inviteType) {
                  case 0:
                    window['$']('#panelInvitationsTab').click();
                    break
                  case 1:
                    window['$']('#panelEventPageInvitationsTab').click();
                    break;
                }
                break;
            }
            window['$']('#inviteVirtualGuestsModal').modal('hide');
        }, () => {});
        break;
    }
  }

  

  onClickReport(event, type) {
    switch(event.type) {
      case 0:
        this.router.navigateByUrl(`/event/in-person/${event.inPersonEventInfo.id}/report`)
        break;
      case 1:
        this.router.navigateByUrl(`/event/virtual/${event.virtualEventInfo.id}/report`)
        break;
      case 2:
        if(type === 0) {
          this.router.navigateByUrl(`/event/in-person/${event.hybridEventInfo.inPersonEvent.id}/report`)
        } else if (type === 1) {
          this.router.navigateByUrl(`/event/virtual/${event.hybridEventInfo.virtualEvent.id}/report`)
        }
    }
  }

  getLinkId(link, event) {
    switch(event.type) {
      case 1:
        return `${link}_${event.virtualEventInfo.id}`;
      case 2:
        return `${link}_${event.hybridEventInfo.virtualEvent.id}`;
    }
    return `${link}_undefined`;
  }
}
